import React, { useMemo } from 'react';
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { startOfWeek, endOfWeek, textfieldDateFormat } from "../../../utils/dateFunctions";
import { getAPIDataReturn, getAPIDataParamsReturn, postApiOrThrow, getAPIData, getAPIDataParams } from "../../../utils/apiFunction";
import { numberFormatwithNeg } from "../../../utils/numberFunctions";
import Div from "@jumbo/shared/Div";
import { adalApiFetch } from '../../../../adalConfig';
import HistoryIcon from '@mui/icons-material/History';
import ArticleIcon from '@mui/icons-material/Article';
import ProcessStockForm from './ProcessStockForm';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import Switch from '@mui/material/Switch';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { saveLabel } from '../../../utils/processing/labels';
import FormModal from '../../../components/FormModal';
import SelectInventoryForm from '../../Processing/Forms/SelectInventoryForm';
import Typography from '@mui/material/Typography';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import Button from '@mui/material/Button';
import DropZone from "../../../components/DropZone";
import { SelectTextFieldNew } from "../../../components/SelectTextField";
import ControlledTextField from "../../../components/ControlledTextField";
import DriverSelect from "../../../components/DriverEntry";
import SubmitButtonDisplayer from "../../../components/SubmitButtonDisplayer";
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import StaffMember from "../../../components/StaffMember";
import { ACCESS, ACCESS_SECTIONS } from '../../../utils/constants/access';
import { checkAccess } from '../../../utils/roleFunctions';
import { number } from 'prop-types';
import { getOysterGrades, gradeSort } from "../../../definitions/oysters";
import { CircularProgress } from '@mui/material';
import { WAREHOUSEMATCHES } from '../../../utils/constants/warehouse';
import HalfShellStartProcessStockForm from './HalfShellStartProcessStockForm';
import { isNotNullorUndefined } from '../../../utils/appHelpers';
import FinishStaffFromBench from './FinishStaffFromBenchForm';
import DeleteCurrentRun from '../../../components/DeleteCurrentRun';

const HalfshellProcessForm = (props) => {
    const uri = process.env.REACT_APP_BASE_URL;
    const hasStarted = !(props.selectedLine?.processingStatus === 'Not started');
    const [totalToAdd, setTotalToAdd] = React.useState(0);
    const [completed, setCompleted] = React.useState(props.completed);
    const [edit, setEdit] = React.useState(props.edit);
    const [error, setError] = React.useState(null);
    const [loading, setLoading] = React.useState(false);
    const [oystersIn, setOystersIn] = React.useState([{}]);
    const [currentOutputs, setCurrentOutputs] = React.useState(null);
    const [traySize, setTraySize] = React.useState(1);//get prev used tray size
    const [secondaryHalfshell, setSecondaryHalfshell] = React.useState(0);
    const [stockItems, setStockItems] = React.useState(null);
    const [stockItem, setStockItem] = React.useState(null);
    const [openCFD, setOpenCFD] = React.useState(false);
    const [openInv, setOpenIv] = React.useState(false);
    const [editBench, setEditBench] = React.useState(null);
    const [openAddInv, setOpenAddInv] = React.useState(false);
    const [grades, setGrades] = React.useState([]);
    const [showDelete, setShowDelete] = React.useState(false);
    const [showHistory, setShowHistory] = React.useState(false);
    const Swal = useSwalWrapper();
    const [equipment, setEquipment] = React.useState(null);
    const requiredEditAccess = { key: ACCESS_SECTIONS.PROCESSING, value: ACCESS.EDIT };
    const requiredAdminAccess = { key: ACCESS_SECTIONS.PROCESSING, value: ACCESS.ADMIN };
    const [reload, setReload] = React.useState(false);
    const [selectedBench, setSelectedBench] = React.useState(props.selectedBench);
    const [prOutputs, setPROutputs] = React.useState(null);
    // Mixed group helpers based on selected bench's groupItems (authoritative for stock items)
    const mixedGroupId = useMemo(() => (selectedBench?.mixedGroupId || selectedBench?.MixedGroupId || null), [selectedBench]);
    const groupItemsSB = useMemo(() => (Array.isArray(selectedBench?.groupItems) ? selectedBench.groupItems : []), [selectedBench]);
    const isMixed = useMemo(() => !!(mixedGroupId && groupItemsSB.length > 0), [mixedGroupId, groupItemsSB]);
    const outputsRunId = useMemo(() => {
        if (isMixed) {
            const ids = groupItemsSB
                .map(gi => Number(gi?.id ?? gi?.processRunId))
                .filter(n => Number.isFinite(n));
            if (ids.length > 0) return Math.min(...ids);
        }
        return selectedBench?.id;
    }, [isMixed, groupItemsSB, selectedBench]);
    const groupInputTotal = useMemo(() => {
        if (!isMixed) return selectedBench?.quantity ?? null;
        const sum = groupItemsSB.reduce((p, gi) => p + Number(gi?.quantity ?? 0), 0);
        return sum;
    }, [isMixed, groupItemsSB, selectedBench]);
    const groupGradeBreakdown = useMemo(() => {
        if (!isMixed) return null;
        const total = groupItemsSB.reduce((p, gi) => p + Number(gi?.quantity ?? 0), 0);
        if (total <= 0) return null;
        const parts = groupItemsSB.map(gi => {
            const qty = Number(gi?.quantity ?? 0);
            const pct = Math.round((qty / total) * 100);
            const name = gi?.stockItem?.grade?.description || gi?.stockItem?.description || gi?.stockItemName || `Item ${gi?.stockItemId ?? ''}`;
            return `${name} ${pct}%`;
        });
        return parts.join(' / ');
    }, [isMixed, groupItemsSB]);
    const buildSelectedBench = (data) => {
        setSelectedBench({ ...data, benchDetails: props.selectedBench.benchDetails });
    }

    React.useEffect(() => {
        getOysterGrades().then((data) => {
            setGrades(data);
        });
    }, []);
    //Reload this page
    React.useEffect(() => {
        getAPIData('/StockItems/Get', setStockItems);
    }, []);
    console.log(props.selectedBench)
    const filterPrOutputs = (data) => {
        setPROutputs(data.filter((pr) => pr.processLine?.isHalfshell));
    }

    React.useEffect(() => {
        // If this bench is a mixed group, fetch each sibling run and rebuild a combined bench
        const loadRuns = async () => {
            try {
                const incoming = props.selectedBench;
                const mgid = incoming?.mixedGroupId || incoming?.MixedGroupId;
                const siblings = Array.isArray(incoming?.groupItems) ? incoming.groupItems : [];
                if (mgid && siblings.length > 0) {
                    const runIds = siblings
                        .map(gi => Number(gi?.id ?? gi?.processRunId))
                        .filter(n => Number.isFinite(n));
                    // Fetch all runs in parallel
                    const runs = await Promise.all(runIds.map(id => getAPIDataReturn('/Processing/GetProcessRun/' + id)));
                    if (runs && runs.length > 0) {
                        // Use the lowest ID run as the base
                        const baseRun = runs.reduce((min, r) => (r.id < min.id ? r : min), runs[0]);
                        const combinedQty = runs.reduce((p, r) => p + Number(r?.quantity ?? 0), 0);
                        const groupItems = runs.map(r => ({
                            id: r.id,
                            processRunId: r.id,
                            stockItemId: r.stockItemId,
                            stockItem: r.stockItem,
                            quantity: r.quantity,
                            mixedGroupId: mgid,
                            lotSerialNbr: r.lotSerialNbr,
                            expiryDate: r.coreInventory?.expiryDate,
                            supplier: r.coreInventory?.receival?.supplier?.name,
                        }));
                        setSelectedBench({
                            ...baseRun,
                            quantity: combinedQty,
                            benchDetails: incoming?.benchDetails,
                            isMixedGroup: true,
                            mixedGroupId: mgid,
                            groupItems,
                        });
                    } else {
                        // Fallback to original bench if no runs returned
                        buildSelectedBench(incoming);
                    }
                } else {
                    // Single run bench - fetch the latest details for the current run id
                    const result = await getAPIDataReturn('/Processing/GetProcessRun/' + incoming.id);
                    buildSelectedBench(result);
                }
            } catch (e) {
                console.log(e);
            }
        };
        loadRuns();
        getAPIDataParams('/Processing/GetTodaysLiveOutputs', filterPrOutputs, { WarehouseId: props.warehouse?.id, StaffMemberId: props.selectedBench.staffMemberId, Date: textfieldDateFormat(props.startDate) })
    }, [reload]);

    React.useMemo(() => {
        setStockItem(selectedBench.stockItem?.grade ? grades?.find((ogn) => { return ((ogn.id === selectedBench.stockItem?.grade?.id) && (ogn.speciesId === selectedBench.stockItem?.species?.id)) }) : null);
    }, [selectedBench, grades]);

    const validate = async () => {
        setLoading(true);
        var warningMessages = [];
        var errorMessages = [];
        //console.log(finished)
    var wipStockCode = generateStockCode(stockItem, traySize, secondaryHalfshell);
    // For mixed groups, fetch outputs from the lowest run id
    var currentProcessingOutputs = await getAPIDataParamsReturn('/Processing/GetProcessingOutputs', { ProcessRunId: outputsRunId });
    console.log(selectedBench.quantity, totalToAdd, generateTotalToAdd(totalToAdd, traySize, currentProcessingOutputs, wipStockCode, true),"RATNEXT",stockItem, traySize, secondaryHalfshell)
    const inputCap = isMixed ? Number(groupInputTotal ?? 0) : Number(selectedBench.quantity ?? 0);
    if (inputCap < generateTotalToAdd(totalToAdd, traySize, currentProcessingOutputs, wipStockCode, false)) {
            warningMessages.push("There is more output than input. Remember to add more input to this bench.");
        }
        if ((wipStockCode === null) || (wipStockCode === undefined)) {
            errorMessages.push("This selection does not have an existing stock item, please check your selection");
        }
        //output must be less than = to input


        if (totalToAdd <= 0) {
            errorMessages.push("You must select more than 0");
        }


        const formatErrorMessage = (array) => {
            var errString = '';
            array.map((a) => {
                errString = errString + a + '<br/>';
            });
            return errString;
        }
        if (errorMessages.length > 0) {

            Swal.fire({
                html: formatErrorMessage(errorMessages),
                icon: 'error',
                title: 'Oops...',

            }).then(() => {
                setLoading(false);
            });
        } else if (warningMessages.length > 0) {
            Swal.fire({
                html: formatErrorMessage(warningMessages),
                icon: 'warning',
                title: 'Oops...',
                showCancelButton: true,
                confirmButtonText: 'Yes, Continue',
                cancelButtonText: 'No, I\'ll edit it',

            }).then(result => {
                if (result.value) {
                    submit(currentProcessingOutputs);
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    setLoading(false);
                }
            });
        } else {
            submit(currentProcessingOutputs);
        }
    }
    const submit = async (CPO) => {
        var respArr = [];
        setError(null);
        setLoading(true);
        try {
        var wipStockCode = generateStockCode(stockItem, traySize, secondaryHalfshell);
        var params = {
            // For mixed groups, post output to the lowest process run id
            ProcessRunId: outputsRunId,
            StockItemId: wipStockCode,
            NoOfUnits: generateTotalToAdd(totalToAdd, traySize, CPO, wipStockCode, false),
            Amount: generateTotalToAdd(totalToAdd, traySize, CPO, wipStockCode, true),
        }
        respArr.push(await postApiOrThrow('/Processing/AddUpdateProcessingOutput', params));
        setLoading(false);
        saveLabel(selectedBench, {
            ...stockItem,
            isPopped: secondaryHalfshell === 2,
            isLidOff: secondaryHalfshell === 1,
        }, totalToAdd, totalToAdd * traySize, false);
        if (respArr.reduce((p, c) => (p && c.ok), true)) {
            props.handleClose();
        } else {
            throw new Error("Failed to submit");
        }
        } catch (submitError) {
            setLoading(false);
            setError(submitError?.message || "Failed to submit");
        }
    }
    const generateTotalToAdd = (trays, traySiz, CPO, wipStockCode, oysters) => {
        var totalExisting = CPO.reduce((p, c) => {
            if (wipStockCode === c.stockItemId) {
                if (oysters) {
                    return p + c.quantity;
                } else {
                    return p + c.noOfUnits;
                }
            } else {
                return p;
            }
        }, 0);
        return Number(oysters ? generateTotal(trays, traySiz) : trays) + Number(totalExisting);
    }
    const remSR = (name) => {
        if (name && name.description) {
            return name.description.replace('Sydney Rock', '');
        } else {
            return '';
        }
    }
    const addToTotal = (value) => {
        setTotalToAdd((totalToAdd ? totalToAdd : 0) + value);
    }
    const clearTotal = (value) => {
        setTotalToAdd(0);
    }
    const openSelectInv = () => {
        setOpenIv(true);
    }
    const openCompleteFD = () => {
        setOpenCFD(true);
    }
    const openAddInvPage = () => {
        setOpenAddInv(true);
    }
    const handleCloseAddInv = () => {
        setOpenAddInv(false);
        setReload(!reload)
    }
    const handleCloseCFD = () => {
        setOpenCFD(false);
        setReload(!reload)
        props.handleClose();
    }
    const handleCloseInv = () => {
        setOpenIv(false);
        setReload(!reload)
        props.handleClose();
    }
    const handleCloseHistory = () => {
        setShowHistory(false);
        setReload(!reload)
    }
    const handleCloseDelete = () => {
        setShowDelete(false);
        props.handleClose();
        setReload(!reload)
    }

    const addToPRN = (list) => (value, indexs) => {
        var dataIndex = indexs.dataIndex;
        var rowIndex = indexs.rowIndex;
        console.log(list, value)
        //add extra to bench
        //reload form
        handleCloseInv();
    }
    const generateStockCode = (selStockItem, traySiz, secHS) => {
        //check that all stockitems are loaded
        if (stockItems) {
            return stockItems.find((si) => { return si.myobid === (selStockItem.abv + (secHS === 1 ? 'LO' : 'HS') + (traySiz === 1 ? (secHS===2?'1P':'1D') : (secHS===2?'2P':'2H'))) })?.id;
        }
    }
    const generateTotal = (trays, traySiz) => {
        var dozCount = (trays * (traySiz ? traySiz : 0));
        return dozCount;
    }
    const historyEdit = (index) => {
        const pr = prOutputs[index];
        const mgid = pr?.mixedGroupId || pr?.MixedGroupId;
        if (mgid) {
            const siblings = prOutputs.filter(x => (x?.mixedGroupId || x?.MixedGroupId) === mgid);
            const combinedQty = siblings.reduce((p, s) => p + Number(s?.quantity ?? 0), 0);
            const groupItems = siblings.map(s => ({
                id: s.id,
                processRunId: s.id,
                stockItemId: s.stockItemId,
                stockItem: s.stockItem,
                quantity: s.quantity,
                mixedGroupId: mgid,
                lotSerialNbr: s.lotSerialNbr,
                expiryDate: s.coreInventory?.expiryDate,
                supplier: s.coreInventory?.receival?.supplier?.name,
            }));
            // Pass the combined quantity so ProcessStockForm doesn't scale items down
            setEditBench({ ...pr, quantity: combinedQty, isMixedGroup: true, mixedGroupId: mgid, groupItems });
        } else {
            setEditBench({ ...pr });
        }
        setShowHistory(!showHistory);
    }
    const deleteCurrentRun = (index) => {
        setShowDelete(true);
        setEditBench({ ...prOutputs[index] });

    }
    const getOldLabel = (index, savestockitem) => {
        console.log(savestockitem, prOutputs[index])
        saveLabel({ benchDetails: selectedBench.benchDetails, ...prOutputs[index] }, {
            Species: savestockitem.species ? savestockitem.species.description : '',
            Grade: savestockitem.grade.description,
            isPopped: savestockitem?.isPopped,
            isLidOff: savestockitem?.isLidOff,
        }, '', '', false);
    }
    var dozCount = numberFormatwithNeg(generateTotal(totalToAdd, traySize));
    console.log(stockItem)
    return (
        <Box
            component="form"
            sx={{
                '& .MuiTextField-root': { m: 1, width: '24ch' },
            }}
            noValidate
            autoComplete="off"
        >
            <Typography variant={'h3'} style={{ right: '10%', position: 'absolute', fontSize: '550%' }} >{selectedBench?.benchDetails?.description}</Typography>

            <FormModal open={showHistory} handleClose={handleCloseHistory} title={"Select Inventory"} fixedWidth>
                <ProcessStockForm WIPcode={true} access={props.access} selectedLine={editBench} completed warehouseId={props.warehouse?.id} reload={reload} setReload={setReload} handleClose={handleCloseHistory} edit={true} />
            </FormModal >
            <FormModal open={openInv} handleClose={handleCloseInv} title={"Select Inventory"} fixedWidth>
                <HalfShellStartProcessStockForm access={props.access} handleClose={handleCloseInv} selectedBench={selectedBench} warehouseId={props.warehouse?.id} warehouse={props.warehouse} endProcess={isNotNullorUndefined(props.selectedBench.id)} procRun={prOutputs?.find((pr) => (pr.id === selectedBench.id))} allRuns={prOutputs} />
            </FormModal >
            <FormModal open={openAddInv} handleClose={handleCloseAddInv} title={"Add to Input"} noWidth >
                <AddInventoryForm access={props.access} handleClose={handleCloseAddInv} selectedBench={selectedBench} warehouseId={props.warehouse?.id} warehouse={props.warehouse} />
            </FormModal >
            <FormModal open={showDelete} handleClose={handleCloseDelete} title={"Delete Current Process"} noWidth >
                <DeleteCurrentRun outputs={editBench} access={props.access} handleClose={handleCloseDelete} selectedBench={selectedBench} warehouseId={props.warehouse?.id} warehouse={props.warehouse} />
            </FormModal >
            <FormModal open={openCFD} handleClose={handleCloseCFD} title={"Complete for Day"} noWidth >
                <FinishStaffFromBench access={props.access} handleClose={handleCloseCFD} selectedBench={selectedBench} warehouseId={props.warehouse?.id} warehouse={props.warehouse} />
            </FormModal >
            <Div>
                {/*//comments*/}
                {/*//processing time*/}
                {/*//no of staff on line*/}

                <Grid container spacing={2} mb={1}>

                    <Grid item xs={12} sm={6} >
                        <Typography variant={'h2'}>{selectedBench?.coreInventory.lotSerialNbr}</Typography>
                        <Typography variant={'h3'}>{selectedBench?.stockItem?.description}</Typography>
                        {mixedGroupId && groupGradeBreakdown ? (
                            <Typography variant={'h5'}>Mixed group: {groupGradeBreakdown}</Typography>
                        ) : null}
                        <Typography variant={'h3'}>Input (Doz): {mixedGroupId ? groupInputTotal : selectedBench.quantity}</Typography>
                        <Grid container spacing={2} mb={1}>
                            <Grid item xs={12}  >
                                <Button variant="contained" color="primary" onClick={openAddInvPage}>Add more of this PRN to bench</Button>
                            </Grid>
                            <br />
                            <br />
                            <br />
                            <br />
                            <Grid item xs={12} style={{ borderTop: '1px solid black', marginTop: '30px' }} >
                                <Button variant="contained" color="primary" onClick={openSelectInv}>Select New PRN</Button>
                            </Grid>
                            <br />
                            <br />
                            <br />
                            <br />
                            <Grid item xs={12} style={{ borderTop: '1px solid black', marginTop: '30px' }} >
                                <Button variant="contained" color="primary" onClick={openCompleteFD}>Complete For The Day</Button>
                            </Grid>
                            <Grid item xs={12} style={{ borderTop: '1px solid black', marginTop: '30px' }} >
                                <Typography variant={'h2'} style={{ textDecoration: 'underline' }} >History</Typography>

                                {prOutputs ? prOutputs.map((pr, index) => {
                                    const mgid = pr?.mixedGroupId || pr?.MixedGroupId;
                                    if (mgid) {
                                        // Collapse siblings with the same mixed group: only render the lowest-id run
                                        const siblings = prOutputs.filter(x => (x?.mixedGroupId || x?.MixedGroupId) === mgid);
                                        const minId = Math.min(...siblings.map(s => s.id));
                                        if (pr.id !== minId) return null;
                                        // Aggregate inputs and outputs across siblings
                                        const combinedQty = siblings.reduce((p, s) => p + Number(s?.quantity ?? 0), 0);
                                        const totalForPct = combinedQty || 0;
                                        const outputs = {};
                                        siblings.forEach(s => {
                                            (s.processRunOutputs || []).forEach(o => {
                                                if (outputs[o.stockItemId]) {
                                                    outputs[o.stockItemId].quantity += o.quantity;
                                                } else {
                                                    outputs[o.stockItemId] = { quantity: o.quantity, stockItem: o.stockItem };
                                                }
                                            });
                                        });
                                        return <div key={`mg-${mgid}`} style={{ display: 'block' }} >
                                            <IconButton style={{ paddingBottom: '15px' }} variant={'h3'} onClick={() => { historyEdit(index) }}><EditIcon /></IconButton>
                                            <Typography style={{ display: 'inline' }} variant={'h5'}>{pr.lotSerialNbr}
                                                <Typography style={{ display: 'inline', paddingLeft: '20px' }} variant={'h5'}>In: {combinedQty}</Typography>
                                                <Typography style={{ display: 'inline', paddingLeft: '20px' }} variant={'h5'}>Out: {Object.keys(outputs).map((c) => (
                                                    <span key={`o-${mgid}-${c}`}><a style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => getOldLabel(index, outputs[c].stockItem)} >{outputs[c].stockItem ? outputs[c].stockItem?.grade?.description : '+'}</a> :{outputs[c].quantity} </span>
                                                ))}</Typography>
                                                {pr.id === selectedBench.id ? <IconButton style={{ paddingBottom: '15px' }} variant={'h3'} onClick={() => { deleteCurrentRun(index) }}>< DeleteIcon /></IconButton> : null}
                                            </Typography>
                                        </div>
                                    } else {
                                        // Single run entry
                                        var outputs = {};
                                        for (var i = 0; i < pr.processRunOutputs.length; i++) {
                                            if (outputs[pr.processRunOutputs[i].stockItemId]) {
                                                outputs[pr.processRunOutputs[i].stockItemId].quantity = outputs[pr.processRunOutputs[i].stockItemId].quantity + pr.processRunOutputs[i].quantity;
                                            } else {
                                                outputs[pr.processRunOutputs[i].stockItemId] = {
                                                    quantity: pr.processRunOutputs[i].quantity, stockItem: pr.processRunOutputs[i].stockItem
                                                }
                                            }
                                        }
                                        return <div key={`pr-${pr.id}`} style={{ display: 'block' }} >
                                            <IconButton style={{ paddingBottom: '15px' }} variant={'h3'} onClick={() => { historyEdit(index) }}><EditIcon /></IconButton>
                                            <Typography style={{ display: 'inline' }} variant={'h5'}>{pr.lotSerialNbr}
                                                <Typography style={{ display: 'inline', paddingLeft: '20px' }} variant={'h5'}>In: {pr.quantity}</Typography>
                                                <Typography style={{ display: 'inline', paddingLeft: '20px' }} variant={'h5'}>Out: {Object.keys(outputs).map((c) => (<span key={`o-${pr.id}-${c}`}><a style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => getOldLabel(index, outputs[c].stockItem)} >{outputs[c].stockItem ? outputs[c].stockItem?.grade?.description : '+'}</a> :{outputs[c].quantity} </span>))}</Typography>
                                                {pr.id === selectedBench.id ? <IconButton style={{ paddingBottom: '15px' }} variant={'h3'} onClick={() => { deleteCurrentRun(index) }}>< DeleteIcon /></IconButton> : null}
                                            </Typography>
                                        </div>
                                    }
                                }) : null}

                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant={'h5'}> Tray Size:&nbsp;
                            <ToggleButtonGroup
                                color="primary"
                                aria-label="text alignment"
                                value={traySize}
                                exclusive
                                onChange={(e, v) => { setTraySize(v) }}>
                                <ToggleButton value={1}>1 Doz</ToggleButton>
                                <ToggleButton value={2.5}>2.5 Doz</ToggleButton>
                            </ToggleButtonGroup>
                        </Typography>
                        <Typography variant={'h5'}> 
                            <ToggleButtonGroup
                                color="primary"
                                aria-label="text alignment"
                                value={secondaryHalfshell}
                                exclusive
                                onChange={(e, v) => { setSecondaryHalfshell(v) }}>
                                <ToggleButton value={0}>Half Shell</ToggleButton>
                                <ToggleButton value={1}>Lid Off Only</ToggleButton>
                                <ToggleButton value={2}>Popped</ToggleButton>
                            </ToggleButtonGroup>
                        </Typography>
                        <SelectTextFieldNew disabled={stockItems ? completed : false} state={stockItem} setState={setStockItem} valueFunc={v => v?.id} list={selectedBench.stockItem?.species ? gradeSort(grades?.filter((ogn) => { return ogn.speciesId === selectedBench.stockItem?.species?.id })) : gradeSort(grades)} nameFunc={(g) => g.Grade} />
                        {/*Icon button edit */}
                        <Typography variant={'h1'}>Trays:</Typography>
                        {stockItems?<Grid container spacing={2} mb={1}>
                            {traySize === 1 ?
                                <React.Fragment>
                                    <Grid item xs={4} sm={4} md={3} lg={2.4} >
                                        <AddValueButton addValue={addToTotal} value={20} />
                                    </Grid>
                                    <Grid item xs={4} sm={4} md={3} lg={2.4} >
                                        <AddValueButton addValue={addToTotal} value={10} />
                                    </Grid>
                                    <Grid item xs={4} sm={4} md={3} lg={2.4} >
                                        <AddValueButton addValue={addToTotal} value={5} />
                                    </Grid></React.Fragment> : <React.Fragment>
                                    <Grid item xs={4} sm={4} md={3} lg={2.4} >
                                        <AddValueButton addValue={addToTotal} value={16} />
                                    </Grid>
                                    <Grid item xs={4} sm={4} md={3} lg={2.4} >
                                        <AddValueButton addValue={addToTotal} value={8} />
                                    </Grid>
                                    <Grid item xs={4} sm={4} md={3} lg={2.4} >
                                        <AddValueButton addValue={addToTotal} value={4} />
                                    </Grid>
                                </React.Fragment>}
                            <Grid item xs={4} sm={4} md={3} lg={2.4} >
                                <AddValueButton addValue={addToTotal} value={2} />
                            </Grid>
                            <Grid item xs={4} sm={4} md={3} lg={2.4} >
                                <AddValueButton addValue={addToTotal} value={1} />
                            </Grid>
                            <Grid item xs={4} sm={4} md={3} lg={2.4} >
                                <Button variant="contained" color="error" onClick={clearTotal}>Clear</Button>
                            </Grid>
                        </Grid> : <CircularProgress />}

                        <Typography variant={'h1'}>{numberFormatwithNeg(totalToAdd)} Trays</Typography>
                        <Typography variant={'h1'}>{dozCount} Doz</Typography>

                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            <br />
                            <div style={{ paddingTop: '5px', textAlign: 'left' }}>
                                {checkAccess(props.access, requiredEditAccess) && !error && stockItems ? (loading  ? <CircularProgress /> : <Button variant="contained" color="success" style={{ whiteSpace: 'nowrap', height: '50px', margin: 0 }} onClick={validate} handleClose={props.handleClose} >Add {dozCount} Doz to {selectedBench?.staffMember?.firstname + ' ' + selectedBench?.staffMember?.surname} ({selectedBench?.benchDetails.description})</Button>) : null}
                                {error ? <Typography color="error">{error}</Typography> : null}
                            </div>
                        </Grid>
                    </Grid>


                </Grid>
            </Div>
        </Box >
    );
};

const AddInventoryForm = (props) => {
    const Swal = useSwalWrapper();
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [addQuantity, setAddQuantity] = React.useState(null);
    const [inv, setInv] = React.useState(null);
    React.useEffect(() => {
        setLoading(true)
        const mgid = props.selectedBench?.coreInventory?.mixedGroupId || props.selectedBench?.coreInventory?.MixedGroupId || null;
        const params = {
            IncludeMYOB: false,
            ExpiryDate: props.selectedBench?.coreInventory?.expiryDate,
            LotNbrSubString: props.selectedBench.lotSerialNbr,
            IncludeZero: true,
            WarehouseId: props.warehouseId,
            // Ask API to group mixed groups when present
            GroupByMixedGroupId: true
        };
        getAPIDataParamsReturn('/Inventory/Get', params).then((minv) => {
            setLoading(false);
            if (!Array.isArray(minv)) { setInv(null); return; }
            if (mgid) {
                console.log(mgid)
                var grouped = null;
                    // Fallback: combine client-side by mixedGroupId
                    const items = minv.filter(x => (x?.mixedGroupId || x?.MixedGroupId) === mgid);
                    if (items.length > 0) {
                        const total = items.reduce((p, x) => p + Number(x?.portalQuantity ?? 0), 0);
                        grouped = { ...items[0], portalQuantity: total, mixedGroupId: mgid };
                    }
                setInv(grouped || null);
            } else {
                // Single item bench
                setInv(minv[0] ? minv[0] : null);
            }
        })
    }, []);
    console.log(inv)
    const validate = () => {
        var warningMessages = [];
        var errorMessages = [];
        //console.log(finished)

        //output must be less than = to available stock

        if (addQuantity === null) {
            errorMessages.push("You must enter an aditional quantity");
        }
        if (addQuantity > inv?.portalQuantity) {
            errorMessages.push("You cannot add more than the available quantity")
        }
        if(addQuantity < 0){
            errorMessages.push("You cannot add a negative quantity")
        }

        const formatErrorMessage = (array) => {
            var errString = '';
            array.map((a) => {
                errString = errString + a + '<br/>';
            });
            return errString;
        }
        if (errorMessages.length > 0) {

            Swal.fire({
                html: formatErrorMessage(errorMessages),
                icon: 'error',
                title: 'Oops...',

            });
        } else if (warningMessages.length > 0) {
            Swal.fire({
                html: formatErrorMessage(warningMessages),
                icon: 'warning',
                title: 'Oops...',
                showCancelButton: true,
                confirmButtonText: 'Yes, Continue',
                cancelButtonText: 'No, I\'ll edit it',

            }).then(result => {
                if (result.value) {
                    submit();
                } else if (result.dismiss === Swal.DismissReason.cancel) {

                }
            });
        } else {
            submit();
        }
    }
    const submit = async (finished) => {
        var respArr = [];
        setError(null);
        setLoading(true);
        try {
        const mgid = props.selectedBench?.mixedGroupId || props.selectedBench?.MixedGroupId || null;
        const siblings = Array.isArray(props.selectedBench?.groupItems) ? props.selectedBench.groupItems : [];
        if (mgid && siblings.length > 0) {
            // Distribute addQuantity across each sibling run proportional to current group quantities
            const baseTotal = siblings.reduce((p, gi) => p + Number(gi?.quantity ?? 0), 0);
            let allocations = [];
            if (baseTotal > 0) {
                allocations = siblings.map(gi => ({
                    gi,
                    share: Math.floor((Number(gi?.quantity ?? 0) / baseTotal) * Number(addQuantity || 0))
                }));
                const allocated = allocations.reduce((p, a) => p + a.share, 0);
                let diff = Number(addQuantity || 0) - allocated;
                let idx = 0;
                while (diff !== 0 && idx < allocations.length) {
                    allocations[idx].share += (diff > 0 ? 1 : -1);
                    diff += (diff > 0 ? -1 : 1);
                    idx++;
                }
            } else {
                const n = siblings.length || 1;
                const even = Math.floor(Number(addQuantity || 0) / n);
                allocations = siblings.map(gi => ({ gi, share: even }));
                let rem = Number(addQuantity || 0) - (even * n);
                let i = 0;
                while (rem > 0 && i < allocations.length) { allocations[i].share += 1; rem--; i++; }
            }
            // Increment bags by 1 on the lowest-ID run to preserve total bag count semantics
            const minRunId = Math.min(...siblings.map(s => Number(s?.id ?? s?.processRunId)).filter(Number.isFinite));
            for (const { gi, share } of allocations) {
                const runId = Number(gi?.id ?? gi?.processRunId);
                const bagsInc = runId === minRunId ? 1 : 0;
                const params = {
                    ProcessRunId: runId,
                    ProductionLineId: props.selectedBench?.benchDetails?.id,
                    Amount: Number(gi?.quantity ?? 0) + Number(share ?? 0),
                    Bins: 0,
                    Bags: Number(props.selectedBench?.bags ?? 0) + bagsInc,
                    Staff: props.selectedBench?.staff,
                    StaffMemberId: props.selectedBench?.staffMember.id
                };
                respArr.push(await postApiOrThrow('/Processing/UpdateProcess', params));
            }
        } else {
            console.log(props.selectedBench)
            const params = {
                ProcessRunId: props.selectedBench?.id,
                ProductionLineId: props.selectedBench?.benchDetails?.id,
                Amount: Number(props.selectedBench?.quantity) + Number(addQuantity),
                Bins: 0,
                Bags: Number(props.selectedBench?.bags) + 1,
                Staff: props.selectedBench?.staff,
                StaffMemberId: props.selectedBench?.staffMember.id
            }
            respArr.push(await postApiOrThrow('/Processing/UpdateProcess', params));
        }

        if (respArr.reduce((p, c) => (p && c.ok), true)) {
            props.handleClose();
        } else {
            throw new Error("Failed to submit");
        }
        } catch (submitError) {
            setLoading(false);
            setError(submitError?.message || "Failed to submit");
        }
    }
    return <React.Fragment>
        <ControlledTextField label="Add to Input" type="number" name="add" state={addQuantity} setState={setAddQuantity} number />
        {inv ? <Typography variant={'h5'}>There is {inv?.portalQuantity} Doz Remaining in this {props.selectedBench?.mixedGroupId ? 'mixed group' : 'PRN'}</Typography> : null}
        {error ? <Typography color="error">{error}</Typography> : null}
        {loading ? <CircularProgress /> : <Button variant="contained" color="primary" style={{ whiteSpace: 'nowrap', height: '50px', margin: 0 }} onClick={validate} handleClose={props.handleClose} >Add</Button>}

    </React.Fragment>
}


const AddValueButton = (props) => {

    return <Button
        style={{ width: '60px', height: '60px' }}
        variant="contained"
        color="primary"
        onClick={() => { props.addValue(props.value) }}>
        <Typography variant={'h1'} style={{ color: 'white', margin: 0 }} > +{props.value}</Typography>
    </Button>
}

export default HalfshellProcessForm;


